import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      cursor: 'pointer',
    },
    display: 'flex',
    alignItems: 'center',
    gap: theme.value.spacing,
    padding: '2px',
    '&__switch': {
      height: '1.25rem',
      width: '2.5rem',
      background: theme.value.colors.gray.light2,
      borderRadius: '10px',
      position: 'relative',
      transition: 'background 0.2s ease',
      '&::after': {
        position: 'absolute',
        content: '""',
        top: '2px',
        left: '2px',
        width: '1rem',
        height: '1rem',
        background: '#fff',
        borderRadius: '50%',
        transition: 'left 0.2s ease',
      },
    },
    '&__label': {
      fontSize: '1rem',
      lineHeight: '1.375',
      fontWeight: theme.value.typography.fontWeight.regular,
    },
    '&--checked &__switch': {
      background: theme.value.colors.primary.main,
      '&::after': {
        left: 'calc(1.5rem - 2px)',
      },
    },
    '&--disabled, &--disabled *': {
      cursor: 'not-allowed',
    },
    '&--disabled &__switch': {
      background: theme.value.colors.gray.light3,
    },
    '&--label-left &__switch': {
      order: 1,
    },
  }));
  return baseClass;
};
